import React, { useEffect, useState } from "react";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import { Card, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import MDTypography from "../../components/MDTypography/index";
import { getTimeSpan, newReservationDay } from "../../api/routes";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import MDButton from "../../components/MDButton";
import moment from "jalali-moment";
import Table from "./Table";
import Footer from "examples/Footer";
import { toast } from "react-toastify";

export default function ReservationDays() {
  const m = moment();
  const [timeSpan, setTimeSpan] = useState();
  const [timeSpanData, setTimeSpanData] = useState([]);
  const [selectedDay, setSelectedDay] = useState({
    from: null,
    to: null,
  });
  const [isActive, setIsActive] = useState();
  let startDate = moment.from(`${selectedDay?.from?.year}/${selectedDay?.from?.month}/${selectedDay?.from?.day}`, "fa", "YYYY/MM/DD").locale("en").format("YYYY/MM/DD");
  let endDate = moment.from(`${selectedDay?.to?.year}/${selectedDay?.to?.month}/${selectedDay?.to?.day}`, "fa", "YYYY/MM/DD").locale("en").format("YYYY/MM/DD");

  function getDatesInRange(startDate, endDate) {
    const date = new Date(startDate.getTime());
    const dates = [];
    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  }

  const newStartDate = new Date(startDate);
  const newEndDate = new Date(endDate);

  const gregorianDateRange = getDatesInRange(newStartDate, newEndDate);
  const jalaliDateRange = gregorianDateRange.map(item => moment(item, "YYYY/MM/DD").locale("fa").format("YYYYMMDD"));

  const renderCustomInput = ({ ref }) => (
    <input
      readOnly
      ref={ref}
      placeholder="بازه زمانی تاریخ"
      value={(selectedDay.from && selectedDay.to) ? `${selectedDay?.from?.year}/${selectedDay?.from?.month}/${selectedDay?.from?.day} - ${selectedDay?.to?.year}/${selectedDay?.to?.month}/${selectedDay?.to?.day}` : ""}
      style={{
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: "0.375rem",
        color: "#495057",
        outline: "none",
        height: "44.3px",
        width: "300px",
        fontFamily: "IRANSansX",
      }}
    />
  );
  useEffect(() => {
    getTimeSpan(1, (isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return setTimeSpanData(data);
    });
  }, []);
  const submitReservationDay = () => {
    const data = {
      timeSpanId: timeSpan,
      reservationDateArray: jalaliDateRange,
      isActive,
    };
    newReservationDay(data, (isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else {
        setTimeSpan();
        setSelectedDay({
          from: null,
          to: null,
        });
        toast.success("روز های نوبت دهی اضافه شد!");
      }
    });
  };

  return (
    <>
      <DashboardLayout>
        <MDBox pt={2} mb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDTypography variant="h6" color="white">
                    ثبت روز های نوبت دهی
                  </MDTypography>
                  <DashboardNavbar />
                </MDBox>
                <MDBox pt={6}>
                  <FormControl sx={{ width: "300px", margin: "0 2rem 0 1rem" }}>
                    <InputLabel>شناسه سناریو</InputLabel>
                    <Select value={timeSpan} onChange={(event) => setTimeSpan(event.target.value)} label="شناسه سناریو"
                            sx={{ height: "44.3px" }}>
                      {timeSpanData.sort((a,b)=>a.startTime < b.startTime ? -1 : 1).map((item) =>
                        <MenuItem key={item.timeSpanId}
                                  value={item.timeSpanId}>{item.fullNameGroup} - {item.startTime}</MenuItem>,
                      )}
                    </Select>
                  </FormControl>
                  <DatePicker
                    value={selectedDay}
                    onChange={setSelectedDay}
                    renderInput={renderCustomInput}
                    selectorStartingYear={Number(m?.locale("fa")?.format("YYYY"))}
                    selectorEndingYear={Number(m?.locale("fa")?.format("YYYY")) + 1}
                    minimumDate={{
                      year: Number(m?.locale("fa")?.format("YYYY")),
                      month: Number(m?.locale("fa")?.format("MM")),
                      day: Number(m?.locale("fa")?.format("DD")),
                    }}
                    shouldHighlightWeekends
                    locale="fa"
                    colorPrimary="#0fbcf9"
                    colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                  />
                  <FormControl sx={{ width: "300px", marginLeft: "2rem" }}>
                    <InputLabel>وضعیت نوبت دهی</InputLabel>
                    <Select value={isActive} onChange={(event) => setIsActive(event.target.value)}
                            label="وضعیت نوبت دهی" sx={{ height: "44.3px" }}>
                      <MenuItem value={1}>فعال</MenuItem>
                      <MenuItem value={0}>غیر فعال</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
                <MDButton onClick={submitReservationDay} variant="gradient" color="info"
                          sx={{ width: "140px", margin: "3rem 0 1rem 1rem" }}>
                  ایجاد
                </MDButton>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Table />
        <Footer />
      </DashboardLayout>
    </>
  );
}
